var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReversed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5E90B829-6F7C-4711-8BA9-DEF09217D359") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 47.3062293 0 47.3062293 47.3063103 0 47.3063103"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ideating",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1440--Infobox-landing-page-",
    transform: "translate(-127, -7218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(127, 7218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8180172,47.3063103 L10.4882931,47.3063103 C4.69594828,47.3063103 0,42.6103621 0,36.8180172 L0,10.4882931 C0,4.69594828 4.69594828,0 10.4882931,0 L36.8180172,0 C42.6103621,0 47.3063103,4.69594828 47.3063103,10.4882931 L47.3063103,36.8180172 C47.3063103,42.6103621 42.6103621,47.3063103 36.8180172,47.3063103",
    id: "Fill-1",
    fill: "#F9F9F9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0036862,24.4119621 L20.0036862,19.9939621 L25.9678241,19.9939621 L33.3662724,14.6440655 C34.0258931,14.1667724 34.4164793,13.4026172 34.4164793,12.589031 L34.4164793,7.22697931 L23.164031,15.5808241 C22.2288931,16.2752897 20.9493586,16.2712379 20.0182724,15.5711 L10.4545828,8.61753103 L10.4545828,13.9301517 C10.4545828,14.7445483 10.8459793,15.5095138 11.5072207,15.9859966 L17.5053931,20.0077379 L17.5143069,20.0077379 L10.187169,25.2855138 C9.52592759,25.7619966 9.13453103,26.5269621 9.13453103,27.3413586 L9.13453103,32.6539793 L20.0036862,24.4119621 Z",
    id: "Fill-4",
    fill: "#7689FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3027052,22.8941862 L27.3027052,27.3121862 L21.3385672,27.3121862 L13.940119,32.6620828 C13.2804983,33.1393759 12.8899121,33.903531 12.8899121,34.7171172 L12.8899121,40.079169 L24.1423603,31.7253241 C25.0774983,31.0308586 26.3570328,31.0349103 27.288119,31.7350483 L36.2083948,38.7404793 L36.2083948,33.428669 C36.2083948,32.6142724 35.8161879,31.8484966 35.1557569,31.3728241 L29.8009983,27.2984103 L29.7920845,27.2984103 L37.1192224,22.0206345 C37.7804638,21.5441517 38.1718603,20.7791862 38.1718603,19.9647897 L38.1718603,14.652169 L27.3027052,22.8941862 Z",
    id: "Fill-6",
    fill: "#7689FF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversed);
export default __webpack_public_path__ + "static/media/reversed.e30632dce945c22853434e3991f3fb16.svg";
export { ForwardRef as ReactComponent };